import React, { Component } from "react";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../navigationSection/BottomNavigationMobile";
import Form from "react-bootstrap/Form";
import {
  ReusableOnboardingLink,
  ReusableOnboardingButton,
  ReusableOnboardingMapButton,
} from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import SuggestNewButton from "../../../vendorOnboradingComponents/reusableOnboardingPopupComponent/suggestNew/SuggestNewButton";
import isEmpty from "../../../../store/validation/is-Empty";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import { update_restaurant_pos_restId } from "../../../../store/actions/authAction";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import Media from "react-media";
import { TopTextReusableComponent } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { amApi } from "../../../../api/apiHelper";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { errorAlert } from "../../../../function/alert";

export class EditPointOfSaleScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editButton: false,
      actionButton: false,
      selectedTab: 2,
      all_point_of_sale: [],
      selectedPointOfSale: [],
      primaryPointOfSale: {},
      configured_pos_from_admin: [],
      supported_pos: [],
      pos_restId: "",
      menu_sharing_code: ""
    };
  }

  componentDidMount() {
    if (this.props.auth.loader) {
      this.setState({
        loader: true,
      });
    }
    this.fetchData();
    if (this.props?.onboarding?.pos?.restId) {
      this.setState({ pos_restId: this.props?.onboarding?.pos?.restId });
      this.setState({ menu_sharing_code: this.props?.onboarding?.pos?.menusharingcode });
    }
  }

  fetchData = async () => {
    try {
      const response = await amApi.get("admin/pos");
      if (response && response.data) {
        const filteredData = response.data
          .filter((item) => item.status === true)
          .map((item) => item.pos_config_id._id);
        this.setState({
          configured_pos_from_admin: filteredData,
        });
        console.log(filteredData, "responsedataaaaaaaaaaaaaa");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps.onboarding._id) &&
      !isEmpty(nextProps.point_of_sale) &&
      !nextState.hasSetMapProps
    ) {
      let selectedPointOfSale = nextProps.onboarding.selectedPointOfSale;
      let primaryPointOfSale = nextProps.onboarding.primaryPointOfSale;
      if (
        !isEmpty(nextProps.onboarding.primaryPointOfSale) &&
        !isEmpty(selectedPointOfSale[0])
      ) {
        if (
          nextProps.onboarding.primaryPointOfSale !== "" &&
          isEmpty(selectedPointOfSale[0]._id) &&
          selectedPointOfSale.length > 0 &&
          isEmpty(primaryPointOfSale._id)
        ) {
          selectedPointOfSale = nextProps.point_of_sale.filter((accesstype) =>
            selectedPointOfSale.includes(accesstype._id)
          );
          primaryPointOfSale = nextProps.point_of_sale.filter(
            (accesstype) => accesstype._id === primaryPointOfSale
          )[0];
        }
      }
      let all_point_of_sale = nextProps.point_of_sale.filter(
        (accesstype) =>
          !selectedPointOfSale.some(
            (selected) => selected._id === accesstype._id
          ) && accesstype.status !== "NOTAPPROVED"
      );
      return {
        all_point_of_sale: all_point_of_sale,
        selectedPointOfSale: !isEmpty(selectedPointOfSale)
          ? selectedPointOfSale
          : [],
        primaryPointOfSale: !isEmpty(primaryPointOfSale)
          ? primaryPointOfSale
          : {},
        hasSetMapProps: true,
      };
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }

  /****************************************
   * @DESC - Accessbility SELECTOR
   ****************************************/
  onRestaurantSelectorArraySelector = (icon, index) => (e) => {
    let buttonArray = this.state.all_point_of_sale;
    buttonArray.splice(index, 1);
    let Restaurant = this.state.selectedPointOfSale;
    let primaryIcon = this.state.primaryPointOfSale;
    if (Restaurant.length === 0 || primaryIcon === {}) {
      Restaurant.push(icon);
      this.setState({
        selectedPointOfSale: Restaurant,
        primaryPointOfSale: icon,
        actionButton: true,
      });
    } else {
      let isAlreadyPresent = Restaurant.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = Restaurant.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          Restaurant.splice(indexOf, 1);
        }
      } else {
        Restaurant.push(icon);
      }
    }
    this.setState({
      selectedPointOfSale: Restaurant,
      actionButton: true,
    });
  };

  onRestaurantsPrimarySelector = (icon) => (e) => {
    this.setState({
      primaryPointOfSale: icon,
      actionButton: true,
    });
  };

  /****************************************
   * @DESC - Remove Primary button handler
   ****************************************/
  removeButton = (icon) => (e) => {
    let { all_point_of_sale, selectedPointOfSale, primaryPointOfSale } =
      this.state;

    let iconIndexAtAllIcons = all_point_of_sale.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconIndexAtSelectedIcons = selectedPointOfSale.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconAtPrimaryIcon =
      !isEmpty(primaryPointOfSale) && primaryPointOfSale._id === icon._id
        ? true
        : false;
    if (selectedPointOfSale.length === 0) {
      selectedPointOfSale.push(icon);
      all_point_of_sale.splice(iconIndexAtAllIcons, 1);
      primaryPointOfSale = icon;
    } else if (iconAtPrimaryIcon) {
      selectedPointOfSale.splice(iconIndexAtSelectedIcons, 1);
      all_point_of_sale.push(icon);
      if (selectedPointOfSale.length === 1) {
        primaryPointOfSale = selectedPointOfSale[0];
      } else {
        primaryPointOfSale = {};
      }
    } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
      selectedPointOfSale.splice(iconIndexAtSelectedIcons, 1);
      all_point_of_sale.push(icon);
      if (selectedPointOfSale.length === 1) {
        primaryPointOfSale = selectedPointOfSale[0];
      }
    } else {
      selectedPointOfSale.push(icon);
      all_point_of_sale.splice(iconIndexAtAllIcons, 1);
    }
    this.setState({
      selectedPointOfSale: selectedPointOfSale,
      all_point_of_sale: all_point_of_sale,
      primaryPointOfSale: primaryPointOfSale,
      actionButton: true,
    });
  };

  editClick = (e) => {
    this.setState({
      editButton: !this.state.editButton,
    });
    if (this.props?.onboarding?.pos?.restId) {
      this.setState({ pos_restId: this.props?.onboarding?.pos?.restId });
      this.setState({ menu_sharing_code: this.props?.onboarding?.pos?.menusharingcode });
    }
  };

  onWithOutApiCall = (e) => {
    const formData_restId = {
      pos: {
        posId: this.state.primaryPointOfSale?._id,
        restId: this.state.pos_restId,
        menusharingcode: this.state.menu_sharing_code,
      },
    };
    console.log(formData_restId)
    this.props.update_restaurant_pos_restId(
      this.props?.onboarding?._id,
      formData_restId,
      () => {
        console.log("response")
        this.props.history.push({
          pathname: "/profile",
        });
      }, (err) => {
        console.log(err);
        errorAlert(err?.response?.data?.message || "Duplicate ID found!")
      }
    );
  };

  onHandleSubmit = (e) => {
    e.preventDefault();

    const formData = {
      vendor_id: this.props.onboarding.vendor_id,
      id: this.props.onboarding._id,
      selectedPointOfSale: this.state.selectedPointOfSale,
      primaryPointOfSale: this.state.primaryPointOfSale,
    };
    this.props.create_and_update_restaurant(formData);
    const formData_restId = {
      pos: {
        posId: this.state.primaryPointOfSale?._id,
        restId: this.state.pos_restId,
        menusharingcode: this.state.menu_sharing_code,
      },
    };
    this.props.update_restaurant_pos_restId(
      this.props?.onboarding?._id,
      formData_restId
    );
    this.setState({
      actionButton: false,
    });
    this.props.history.push("/profile");
  };

  renderDressCodeFields = () => {
    const {
      selectedPointOfSale,
      primaryPointOfSale,
      actionButton,
      editButton,
    } = this.state;
    return (
      <React.Fragment>
        <div className="restaurant_type_onboarding_main">
          <div>
            <div className="cuisine-main ">
              {editButton === true ? (
                <div>
                  <div
                    className={
                      this.state.all_point_of_sale.length > 8
                        ? "cuisine-main-padding-border"
                        : ""
                    }
                  >
                    <div
                      id="box-style"
                      className="cuisine-main-padding justify-content-start column-2"
                      style={{ display: "flex", flexWrap: "wrap" }}
                    >
                      {this.state.all_point_of_sale.map((icon, index) => (
                        <ReusableOnboardingMapButton
                          key={index}
                          classsection="onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                          src={icon.icon}
                          title={icon.title}
                          onClick={
                            editButton === true
                              ? this.onRestaurantSelectorArraySelector(
                                  icon,
                                  index
                                )
                              : null
                          }
                          isSupported={this.state.configured_pos_from_admin.includes(
                            icon._id
                          )}
                        />
                      ))}
                    </div>
                  </div>
                  <div className="suggest-button-heading">
                    <SuggestNewButton categoryId={"5fa2abe7a930bc32ce5790c7"} />
                  </div>
                </div>
              ) : null}

              {/** */}
              {!isEmpty(selectedPointOfSale) && editButton === true ? (
                <React.Fragment>
                  <div className="f14-500 mt-4">
                    Out of the selections below, which one is primary?
                  </div>
                  <div className="f11-400 opacity5">
                    Select only one of the options below as a default - this is
                    shown to the user.
                  </div>
                </React.Fragment>
              ) : null}

              <div
                className="cuisine-main-padding-bottom justify-content-start column-2 mobile-device-bottom-margin mt-4"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                {selectedPointOfSale.map((icon, index) => (
                  <ReusableOnboardingMapButton
                    key={index}
                    classsection={
                      // icon._id === primaryPointOfSale._id
                      //   ?
                      "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type"
                      // : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active"
                    }
                    src={icon.icon}
                    title={icon.title}
                    onClick={
                      editButton === true
                        ? this.onRestaurantsPrimarySelector(icon)
                        : null
                    }
                    displayPrimary={
                      icon._id === primaryPointOfSale._id ? true : false
                    }
                    displayRemove={editButton === true ? true : false}
                    removeButtonClick={this.removeButton(icon)}
                  />
                ))}
              </div>
            </div>
          </div>
          {editButton ? (
            <>
              <div style={{ width: "50%" }}>
                <div className="f14-500"> Rest ID</div>
                <div className="my-2">
                  <NewInputText
                    extraClass="m-0"
                    displayLabel={true}
                    controlId="name"
                    variant="outlined"
                    name="name"
                    inputType="text"
                    onChange={(e) => {
                      this.setState({ pos_restId: e.target.value });
                    }}
                    value={this.state.pos_restId}
                    required="required"
                  />
                </div>
              </div>
              <div style={{ width: "50%" }}>
                <div className="f14-500">Menu Sharing Code</div>
                <div className="my-2">
                  <NewInputText
                    extraClass="m-0"
                    displayLabel={true}
                    controlId="name"
                    variant="outlined"
                    name="name"
                    inputType="text"
                    onChange={(e) => {
                      this.setState({ menu_sharing_code: e.target.value });
                    }}
                    value={this.state.menu_sharing_code}
                    required="required"
                  />
                </div>
              </div>
            </>
          ) : null}

          <div className="onboarding-map-setup-screen-autodetect-button">
            {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
            <ReusableOnboardingLink
              buttonTitle="Back Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
              buttonText="Back"
              link="/profile"
            />
            {editButton === true ? (
              <ReusableOnboardingButton
                buttonTitle="Save"
                buttonClass={
                  selectedPointOfSale.length <= 0 ||
                  isEmpty(primaryPointOfSale._id)
                    ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                    : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                }
                disabled={
                  selectedPointOfSale.length <= 0 ||
                  isEmpty(primaryPointOfSale._id)
                    ? true
                    : false
                }
                buttonText="Save"
                onClick={actionButton === false ? this.onWithOutApiCall : null}
                buttonType={actionButton === false ? "button" : "submit"}
              />
            ) : null}
            {/* </div> */}
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    const { editButton } = this.state;
    if (this.state.loader) {
      return <AmealioLoader />;
    }
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>

            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/profile"
                displayText="Back"
              />
              <div
                id="onboarding-scrollbar"
                className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
              >
                <div className=" p-0">
                  <div>
                    <TopTextReusableComponent
                      headingText="Point of Sale System"
                      headingParagraph={
                        editButton === true
                          ? "This system is for simply put, every time a customer makes a purchase at your store they’re completing a point of the sale transaction."
                          : null
                      }
                      displayEdit={editButton}
                      onClickEdit={this.editClick}
                    />
                  </div>
                  <Form noValidate onSubmit={this.onHandleSubmit}>
                    {this.renderDressCodeFields()}
                  </Form>
                </div>
              </div>
            </div>

            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

EditPointOfSaleScreen.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  point_of_sale: state.category.point_of_sale,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
  update_restaurant_pos_restId,
})(withRouter(EditPointOfSaleScreen));
